import {useCurrency} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useEffect} from 'react'
import {useUpdateOrderMutation} from './ventrata/useUpdateOrderMutation'

export const useOrderCurrencySwitcher = () => {
  const currency = useCurrency()
  const order = OrderProvider.useOrder('optional')
  const setOrder = OrderProvider.useOrderSetter()
  const updateOrderMutation = useUpdateOrderMutation()
  const updateOrder = updateOrderMutation.mutate

  useEffect(() => {
    if (order && order.pricing?.currency !== currency) {
      updateOrder({orderId: order.id, currency}, {onSuccess: setOrder})
    }
  }, [order, currency, setOrder, updateOrder])
}
